import { ILogger, LogLevel } from '@aspnet/signalr';

export class MyLogger implements ILogger {
  public hubConnectionLog: Array<string> = [];

  log(logLevel: LogLevel, message: string) {
    // Use `message` and `logLevel` to record the log message to your own system
    this.hubConnectionLog.push(LogLevel[logLevel] + ': ' + message);
  }
}
